module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_3009.dd881a70.png";